import { SVG_PATHS } from './SvgPaths';

/**
 * Creates an inline SVG string with the specified path and color
 * This version is optimized for both PDF export and live preview
 * @param {string} pathKey - The key for the SVG path in SVG_PATHS
 * @param {string} color - The fill color for the SVG
 * @param {number} size - The size of the SVG (width and height)
 * @returns {string} - The inline SVG string
 */
export const createInlineSvg = (pathKey, color, size = 60) => {
    const path = SVG_PATHS[pathKey];
    if (!path) {
        console.error(`SVG path for key "${pathKey}" not found`);
        return '';
    }

    // Create a proper PDF and preview-compatible SVG image tag
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24">
      <path d="${path}" fill="${color}" />
    </svg>`;

    // Encode the SVG for use in a data URI
    const encoded = encodeURIComponent(svgString)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22');

    // Note: Using a div wrapper with explicit alignment styles that work in both preview and PDF
    return `<div class="icon-wrapper" style="width:${size}px; height:${size}px; display:block; margin-left:0; margin-right:auto; text-align:left;">
      <img src="data:image/svg+xml,${encoded}" 
           width="${size}" 
           height="${size}" 
           alt="Icon" 
           style="display:block; width:${size}px; height:${size}px; margin-left:0; margin-right:auto;" />
    </div>`;
};

/**
 * Generate all icon SVGs with the specified color
 * @param {string} color - The color to use for the icons
 * @param {number} size - The size of the icons
 * @returns {Object} - An object with keys for each icon and values as inline SVG strings
 */
export const generateAllIconSvgs = (color, size = 60) => {
    // Make sure we have a valid color
    const safeColor = color || '#145049';

    return {
        emailDomain: createInlineSvg('alternateEmail', safeColor, size),
        spoofing: createInlineSvg('mail', safeColor, size),
        urgency: createInlineSvg('urgency', safeColor, size),
        links: createInlineSvg('link', safeColor, size),
        attachments: createInlineSvg('attachFile', safeColor, size),
        sensitiveInfo: createInlineSvg('searchCheck', safeColor, size)
    };
};